import { render, staticRenderFns } from "./siteLanguage.vue?vue&type=template&id=24513bef&scoped=true"
import script from "./siteLanguage.vue?vue&type=script&lang=js"
export * from "./siteLanguage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24513bef",
  null
  
)

export default component.exports